import React from 'react'
import * as style from 'src/app/BulkInvite/BulkInviteSendingToastMessage.style'
import { useBulkInviteStrings } from 'src/app/BulkInvite/useBulkInviteStrings'
import TestId from 'src/components/TestId/TestId'

interface BulkInviteSendingToastMessageProps {
  /** Count of VALID_NET_NEW rows queued for send. */
  count: number
}

/**
 * The async "being sent" toast surfaced after a successful bulk-invite send. The
 * modal closes immediately and the admin lands on the People page, so this toast
 * is the only confirmation that the background job is running.
 *
 * TODO: surface per-row partial-failure results after close as a follow-up —
 * today this is a single, optimistic "being sent" message.
 */
const BulkInviteSendingToastMessage: React.FC<
  BulkInviteSendingToastMessageProps
> = ({ count }): React.ReactNode => {
  const strings = useBulkInviteStrings()

  return (
    <TestId testId="bulkInviteSendingToast">
      <span css={style.message}>
        {count === 1
          ? strings.sendingToastOne
          : strings.sendingToast(<span css={style.count}>{count}</span>)}
      </span>
    </TestId>
  )
}

export default BulkInviteSendingToastMessage
